import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { orderPageInitialState, OrderPageState } from './OrderPageState';
import { useLanguageChange } from '../hooks/useLanguageChange';
import { TipType } from '../../api';
import { OrderPageIntent } from '../OrderPageIntent';

export function useOrderPageProviderBase() {
  const [searchParams] = useSearchParams();
  const [orderPageState, setOrderPageState] = useState<OrderPageState>(orderPageInitialState);
  const shouldUseDefaultTheme = searchParams.get('defaulttheme') === 'true';
  const { isLoading: isLoadingLanguage } = useLanguageChange(orderPageState.account?.default_system_language);

  const setPersonalDetails = useCallback((personalDetails: any) => {
    setOrderPageState((prev) => ({ ...prev, personalDetails }));
  }, []);

  const setPaymentUrl = useCallback((val: string) => {
    setOrderPageState((prev) => ({ ...prev, paymentUrl: val }));
  }, []);

  const setTip = useCallback((type: TipType, value: number) => {
    setOrderPageState((prev) => ({ ...prev, tip: { value, type } }));
  }, []);

  const setActiveStep = useCallback((val: number) => {
    setOrderPageState((prev) => ({ ...prev, activeStep: val }));
  }, []);

  const setActiveStepAndOrderPageIntent = useCallback((activeStep: number, orderPageIntent: OrderPageIntent) => {
    setOrderPageState((prev) => ({ ...prev, activeStep, orderPageIntent }));
  }, []);

  const [disclaimersAccepted, setDisclaimersAccepted] = useState(false);
  const [disclaimersError, setDisclaimersError] = useState(false);
  const [sessionTtlMilliseconds, setSessionTtlMilliseconds] = useState<number | null>(null);

  const onDisclaimersChange = useCallback((accepted: boolean) => {
    setDisclaimersAccepted(accepted);
    if (accepted) {
      setDisclaimersError(false);
    }
  }, []);

  return {
    orderPageState,
    setOrderPageState,
    shouldUseDefaultTheme,
    isLoadingLanguage,
    setPersonalDetails,
    setPaymentUrl,
    setTip,
    setActiveStep,
    setActiveStepAndOrderPageIntent,
    disclaimersAccepted,
    disclaimersError,
    setDisclaimersError,
    onDisclaimersChange,
    sessionTtlMilliseconds,
    setSessionTtlMilliseconds,
  };
}
